import {
    STORE_ORDER_ACTION,
    SET_ORDER_LOADING_TO_FALSE_MUTATION,
    SET_ORDER_LOADING_TO_TRUE_MUTATION,
    SET_ORDER_DATA_MUTATION,
    RETREIVE_ORDER_ACTION,
    SET_PAYLANDS_PARAMS_MUTATION,
    CREATE_PAYMENT_INSTANCE,
    SET_BITCOIN_PARAMS,
    GET_PAYMENT_METHOD,
    RETREIVE_REGIONS,
    RETREIVE_SHIPPING_TYPE,
    SET_REGIONS,
    SET_SHIPPING_TYPE,
    GET_COUPON
} from "./types";
import axios from "axios";
import { goToRouteWithName } from "@/js/mixin";

const wizardActions = {
    [STORE_ORDER_ACTION]({ commit, getters }, payload) {
        commit(SET_ORDER_LOADING_TO_TRUE_MUTATION);
        // ADD coupon info on payload
        if(getters[GET_COUPON]) payload.coupon = getters[GET_COUPON].code_name;
        axios
            .post("/api/order/save", {
                payload: JSON.stringify(payload)
            })
            .then(res => {
                const method = getters[GET_PAYMENT_METHOD];
                switch (method) {
                    case "bitcoin":
                        commit(SET_BITCOIN_PARAMS, res.data);
                        break;
                    case "payland":
                        if (payload.cardUUID) {
                            commit(SET_ORDER_DATA_MUTATION, res.data);
                            router.push({
                                name: "order-placed",
                                params: { order_code: res.data.code }
                            });
                        } else {
                            //Redirect method to credit card payment
                            window.location.href = res.data;
                        }
                        break;
                    case "paragon":
                        if(res.data.error)throw res.data.error['error-message'] || res.data.error['status_description'];

                        window.location.href = res.data['redirect-url'];
                        break;
                    case "transfer":
                        router.push({
                            name: "order-placed",
                            params: { order_code: res.data.code }
                        });
                        break;
                    default:
                        break;
                }
                commit(SET_ORDER_LOADING_TO_FALSE_MUTATION);
            })
            .catch(err => {
                commit(SET_ORDER_LOADING_TO_FALSE_MUTATION);
                app.$toast.open({
                    message: err,
                    type: "error"
                });
                console.error(err);
            });
    },
    [CREATE_PAYMENT_INSTANCE]({ commit }, payload) {
        commit(SET_ORDER_LOADING_TO_TRUE_MUTATION);
        axios
            .get(`/api/order/instance/${payload}`)
            .then(res => {
                commit(SET_PAYLANDS_PARAMS_MUTATION, res.data);
                commit(SET_ORDER_LOADING_TO_FALSE_MUTATION);
            })
            .catch(err => {
                app.$toast.open({
                    message: err,
                    type: "error"
                });
                console.log(err);
            });
    },
    [RETREIVE_ORDER_ACTION]({ commit }, payload) {
        axios
            .get(`/api/order/retreive/${payload}`)
            .then(res => {
                commit(SET_ORDER_DATA_MUTATION, res.data);
            })
            .catch(err => {
                app.$toast.open({
                    message: err,
                    type: "error"
                });
            });
    },
    [RETREIVE_REGIONS]({ commit }, payload) {
        axios
            .get("/api/regions")
            .then(res => {
                commit(SET_REGIONS, res.data);
            })
            .catch(err => {
                console.log(err);
            });
    },
    [RETREIVE_SHIPPING_TYPE]({ commit }, payload) {
        axios
            .post("/api/shipping", {
                payload: JSON.stringify(payload)
            })
            .then(res => {
                if(res.data == 'Not found'){
                   throw "not_found"
                }
                commit(SET_SHIPPING_TYPE, res.data);
            })
            .catch(err => {
                // app.$toast.open({
                //     message: trans[err][window.appLocale],
                //     type: "error"
                // });
            });
    }
};

export default wizardActions;
